import {
  BootstrapData,
  Currency,
  HttpError,
  Locale,
  LoyaltyCurrency,
  LoyaltyProgram,
} from '@rd/types';
import { PaymentProcessingModel } from '@rd/types/payment-processing.model';
import { RoundingPreferenceModel } from '@rd/types/rounding-preference.model';
import { TenantActions, TenantActionTypes } from '../actions/tenant.actions';

export interface TenantState {
  bootstrapLoading: boolean;
  error: HttpError | null;
  locales: Locale[] | null;
  currencies: Currency[] | null;
  loyaltyCurrencies: LoyaltyCurrency[] | null;
  loyaltyPrograms: LoyaltyProgram[] | null;
  timeZoneOffset?: string;
  timeZoneOffsetInMinutes: number;
  roundingPreferences: RoundingPreferenceModel | null;
  paymentProcessingFee: PaymentProcessingModel | null;
  minPointsPercentage: BootstrapData['minPointsPercentage'] | null;
  maxPointsPercentage: BootstrapData['maxPointsPercentage'] | null;
  featureFlags: { [key: string]: boolean } | null;
  pageLoadingState: boolean;
}

const initialState: TenantState = {
  bootstrapLoading: false,
  pageLoadingState: false,
  error: null,
  locales: null,
  currencies: null,
  loyaltyCurrencies: null,
  loyaltyPrograms: null,
  timeZoneOffset: '+00:00',
  timeZoneOffsetInMinutes: 0,
  roundingPreferences: null,
  paymentProcessingFee: null,
  minPointsPercentage: null,
  maxPointsPercentage: null,
  featureFlags: null,
};

export function tenantReducer(
  state: TenantState = initialState,
  action: TenantActions,
): TenantState {
  switch (action.type) {
    case TenantActionTypes.LOAD_BOOTSTRAP:
      return {
        ...state,
        bootstrapLoading: true,
      };
    case TenantActionTypes.LOAD_BOOTSTRAP_SUCCESS:
      return {
        ...state,
        locales: action.payload.locales,
        currencies: action.payload.currencies,
        loyaltyCurrencies: action.payload.loyaltyCurrencies,
        loyaltyPrograms: action.payload.loyaltyPrograms,
        timeZoneOffset: action.payload.timeZoneOffset,
        timeZoneOffsetInMinutes: action.payload.timeZoneOffsetInMinutes,
        roundingPreferences: action.payload.roundingPreferences,
        paymentProcessingFee: action.payload.paymentProcessingFee,
        error: null,
        bootstrapLoading: false,
        minPointsPercentage: action.payload.minPointsPercentage,
        maxPointsPercentage: action.payload.maxPointsPercentage,
        featureFlags: action.payload.featureFlags,
      };

    case TenantActionTypes.LOAD_BOOTSTRAP_FAIL:
      return {
        ...state,
        error: action.payload,
        bootstrapLoading: false,
      };

    case TenantActionTypes.SET_PAGE_LOADING_STATE:
      return {
        ...state,
        pageLoadingState: action.payload.isLoading,
      };
  }

  return state;
}
